import { FiSearch } from 'react-icons/fi';
import DateRangePicker from '../ui/DateRangePicker';

interface Props {
  search: string;
  dateFrom: string;
  dateTo: string;
  onSearchChange: (v: string) => void;
  onDateChange?: (from: string, to: string) => void;
  hideDateRange?: boolean;
}

const TaskSheetToolbar: React.FC<Props> = ({
  search,
  dateFrom,
  dateTo,
  onSearchChange,
  onDateChange,
  hideDateRange = false,
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
      {/* Search */}
      <div className="relative flex-1">
        <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-base" />
        <input
          type="text"
          placeholder="Search by employee name..."
          value={search}
          onChange={e => onSearchChange(e.target.value)}
          className="w-full pl-9 pr-4 py-2.5 rounded-full border border-gray-200 text-sm text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 bg-white"
        />
      </div>

      {/* Date range picker */}
      {!hideDateRange && onDateChange && (
        <DateRangePicker
          dateFrom={dateFrom}
          dateTo={dateTo}
          onChange={onDateChange}
        />
      )}
    </div>
  );
};

export default TaskSheetToolbar;
